export default "__VITE_ASSET__476ca19e__"